function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m90.878906 0h30v75.855469h-30zm0 0",
  fill: "#ffd422"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m150.929688 0h30v75.855469h-30zm0 0",
  fill: "#ffd422"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m210.976562 0h30v75.855469h-30zm0 0",
  fill: "#ffd422"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m271.023438 0h30v75.855469h-30zm0 0",
  fill: "#ff9f22"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m331.070312 0h30v75.855469h-30zm0 0",
  fill: "#ff9f22"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m391.121094 0h30v75.855469h-30zm0 0",
  fill: "#ff9f22"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m90.878906 436.144531h30v75.855469h-30zm0 0",
  fill: "#ffd422"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m150.929688 436.144531h30v75.855469h-30zm0 0",
  fill: "#ffd422"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m210.976562 436.144531h30v75.855469h-30zm0 0",
  fill: "#ffd422"
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#ff9f22"
}, React.createElement("path", {
  d: "m271.023438 436.144531h30v75.855469h-30zm0 0"
}), React.createElement("path", {
  d: "m331.070312 436.144531h30v75.855469h-30zm0 0"
}), React.createElement("path", {
  d: "m391.121094 436.144531h30v75.855469h-30zm0 0"
}), React.createElement("path", {
  d: "m436.144531 90.878906h75.855469v30h-75.855469zm0 0"
}), React.createElement("path", {
  d: "m436.144531 150.929688h75.855469v30h-75.855469zm0 0"
}), React.createElement("path", {
  d: "m436.144531 210.976562h75.855469v30h-75.855469zm0 0"
}), React.createElement("path", {
  d: "m436.144531 271.023438h75.855469v30h-75.855469zm0 0"
}), React.createElement("path", {
  d: "m436.144531 331.070312h75.855469v30h-75.855469zm0 0"
}), React.createElement("path", {
  d: "m436.144531 391.121094h75.855469v30h-75.855469zm0 0"
}));

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0 90.878906h75.855469v30h-75.855469zm0 0",
  fill: "#ffd422"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0 150.929688h75.855469v30h-75.855469zm0 0",
  fill: "#ffd422"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0 210.976562h75.855469v30h-75.855469zm0 0",
  fill: "#ffd422"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0 271.023438h75.855469v30h-75.855469zm0 0",
  fill: "#ffd422"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0 331.070312h75.855469v30h-75.855469zm0 0",
  fill: "#ffd422"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0 391.121094h75.855469v30h-75.855469zm0 0",
  fill: "#ffd422"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "m457 55h-201l-20.015625 201 20.015625 201h201zm0 0",
  fill: "#00884f"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "m55 55h201v402h-201zm0 0",
  fill: "#00cc76"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "m335.644531 176.355469h-79.644531l-20.015625 78.785156 20.015625 80.503906h79.644531zm0 0",
  fill: "#b4d2d7"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "m176.355469 176.355469h79.644531v159.289062h-79.644531zm0 0",
  fill: "#e1ebf0"
});

var SvgCpu = function SvgCpu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512.00002",
    width: "512pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCpu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cpu.470a8cae.svg";
export { ForwardRef as ReactComponent };